import React from 'react';
import classnames from 'classnames';
import type { IPipelineEvent } from '../../type';
import { getDelaySummaryLabel } from '../../utils/delayDates';
import {
  getEventCardPrimaryLabel,
  getEventCardTypeSuffix,
} from '../../utils/eventDisplay';
import './index.scss';

interface IDelayEventBubbleContentProps {
  evt: IPipelineEvent;
}

const DelayEventBubble: React.FC<IDelayEventBubbleContentProps> = ({
  evt,
}) => {
  const dates = evt.dates || [];
  const label = getEventCardPrimaryLabel(evt);
  const typeLabel = getEventCardTypeSuffix(evt);
  const typeSuffix = typeLabel ? ` (${typeLabel})` : '';
  const summary = getDelaySummaryLabel(dates);

  return (
    <div className="dbs-pipeline-delay-bubble">
      <div className="dbs-pipeline-delay-bubble__title">
        {/* label+type suffix in bold; original date in normal weight */}
        <span className="dbs-pipeline-delay-bubble__title-name">
          {label}{typeSuffix}
        </span>
        <span className="dbs-pipeline-delay-bubble__title-original">
          {` (Original ${dates[0]})`}
        </span>
      </div>
      <div className="dbs-pipeline-delay-bubble__dates">
        {dates.map((date, index) => {
          const isLatest = index === dates.length - 1;

          return (
            <React.Fragment key={`${date}-${index}`}>
              {index > 0 && (
                <span className="dbs-pipeline-delay-bubble__arrow" aria-hidden>
                  →
                </span>
              )}
              <span
                className={classnames('dbs-pipeline-delay-bubble__date-pill', {
                  'dbs-pipeline-delay-bubble__date-pill--latest': isLatest,
                })}
              >
                {date}
              </span>
            </React.Fragment>
          );
        })}
      </div>
      {summary ? (
        <div className="dbs-pipeline-delay-bubble__summary">{summary}</div>
      ) : null}
    </div>
  );
};

export default DelayEventBubble;
